export default "__VITE_ASSET__DWcfa6Hu__"